import { Component, Input, OnInit } from '@angular/core';
import { PublicInstitution } from '../../models/PublicInstitution';
import * as Constants from '../../models/Constants';
import { Router, ActivatedRoute } from '@angular/router';
import { PublicInstitutionsService } from '../../services/public-institutions.service';
import { InstitutionsService } from '../../shared/services/institutions.service';

@Component({
  selector: 'app-public-institutions-detail',
  templateUrl: './public-institutions-detail.component.html',
  styleUrls: ['./public-institutions-detail.component.css']
})
export class PublicInstitutionsDetailComponent implements OnInit {
  publicInstitutionDetail : PublicInstitution[] = [];
  constants: any = Constants;
  agentID: number;
  listDetail: PublicInstitution;
  constructor(private route: ActivatedRoute, private _publicInstitutionsService: PublicInstitutionsService, private _institutions: InstitutionsService) { }

  ngOnInit()
  {
    this._institutions.broadCast.subscribe(broadCast => this.publicInstitutionDetail = broadCast);
    this.route.params.subscribe(params => {
      this.agentID = parseInt(params['id']);
      this.listDetail = this.publicInstitutionDetail.find(x => x.id === this.agentID);
    });

  }

}
